import React from 'react';
import { EmojiWrapper } from './MessageReaction.styled';

type MessageReactionProps = { emoji?: string };

export function MessageReaction({ emoji }: MessageReactionProps) {
  if (!emoji) return null;
  return (
    <EmojiWrapper>
      <span>{emoji}</span>
    </EmojiWrapper>
  );
}
